<template>
  <div
    class="score-modal-objectives__list flat-scrol score-modal-objectives__responsive-from-tablet"
  >
    <div class="score-modal-objectives__list-header">
      <div class="score-modal-objectives__header-wrapper">
        <h5 class="score-modal-objectives__domain-name">
          {{ labName }}
        </h5>
      </div>
      <div class="score-modal-objectives__domain-score-wrapper">
        <div class="score-modal-objectives__domain-score">
          <span class="score-modal-objectives__domain-score-label"
            >Required score:</span
          >
          <span class="score-modal-objectives__domain-score-result">{{
            labAttempt.min_points_to_pass
          }}</span>
        </div>
        <div class="score-modal-objectives__domain-score">
          <span class="score-modal-objectives__domain-score-label"
            >Your score:</span
          >
          <span class="score-modal-objectives__domain-score-result">{{
            attemptUserScore
          }}</span>
        </div>
        <CheckIcon
          class="score-modal-objectives score-modal-objectives--passed"
          v-if="labAttempt.has_passed"
        />
        <XIcon
          v-else
          class="score-modal-objectives score-modal-objectives--failed"
        />
      </div>
    </div>
    <div class="score-modal-objectives__objectives-wrapper">
      <div
        class="score-modal-objectives__objective"
        v-for="(objective, key) in labObjectives"
        :key="key"
      >
        <div
          v-html="objective.description_html"
          class="score-modal-objectives__objective-name"
        ></div>
        <span class="score-modal-objectives__objective-score">
          {{ objective.points }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { CheckIcon, XIcon } from 'vue-feather-icons'

export default {
  name: 'LabScoreModalObjectives',
  components: {
    CheckIcon,
    XIcon,
  },
  props: {
    labAttempt: {
      type: Object,
      required: true,
    },
  },
  computed: {
    labName() {
      return this.labAttempt.lab_session?.lab?.name
    },
    labResultStatus() {
      return this.labAttempt.has_passed ? 'Passed' : 'Failed'
    },
    labObjectives() {
      return this.labAttempt.lab_objectives
    },
    attemptUserScore() {
      return this.labObjectives.reduce((totalPoints, objective) => {
        return (
          totalPoints + (objective.has_passed ? parseInt(objective.points) : 0)
        )
      }, 0)
    },
  },
}
</script>

<style lang="scss" scoped>
.score-modal-objectives__objective-name {
  ::v-deep p {
    margin: 0;
  }
}
</style>
